

module.exports.basketVersion = 'action.basket.version';
module.exports.fatalError = 'action.root.fatalError';
module.exports.menuCategoryIndex = 'action.basket.menuCategoryIndex';
module.exports.currentComponent = 'action.root.currentComponent';
